import Vue from 'vue'
import Router from 'vue-router'
import Login from 'views/login/index'
import forgetPassword from 'views/login/components/forgetPassword'
import appIntroduce from 'views/login/components/appIntroduce' // app介绍
import loginChoose from 'views/login/loginchoose'

import registeredNumber from 'views/login/components/registeredNumber'
import answerRegister from 'views/outsideranswer/AnswerRegister' //校外人员电脑答题登记


import outsiderAnswerList from 'views/outsideranswer/OutsiderAnswerList' //校外人员答题列表
import outsiderAnswer from 'views/outsideranswer/OutsiderAnswer' //校外人员答题

import Layout from 'views/layout/Layout'
import store from '@/store/index'
import {
    Message,
    MessageBox
} from 'element-ui'
import LYCom from '../../static/js/LYCom'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const routes = [{
    path: '/',
    redirect: '/home'
},
{
    path: '/login',
    name: 'login',
    component: Login
},
{
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: forgetPassword
},
{
    path: '/loginchoose',
    name: 'loginchoose',
    component: loginChoose
},
{
    path: '/appIntroduce',
    name: 'appIntroduce',
    component: appIntroduce
},


{
    path: '/registeredNumber',
    name: 'registeredNumber',
    component: registeredNumber
},
{
    path: '/answerRegister',
    name: 'answerRegister',
    component: answerRegister

},
{
    path: '/outsiderAnswerList',
    name: 'outsiderAnswerList',
    component: outsiderAnswerList

},
{
    path: '/outsiderAnswer',
    name: 'outsiderAnswer',
    component: outsiderAnswer

},
{
    path: '/',
    component: Layout,
    children: [{
        path: '/home',
        name: 'home',
        component: () =>
            import('views/homechild/syshome')
    },
    {
        path: '/riskCheck',
        name: 'riskCheck',
        component: () =>
            import('views/riskCheck/index')
    },
    {
        path: '/studentCourse',
        name: 'studentCourse',
        component: () =>
            import('views/studentCourse/index')
    },
    {
        path: '/teacherCourse',
        name: 'teacherCourse',
        component: () =>
            import('views/teacherCourse/index')
    },
    {
        path: '/schoolHome',
        name: 'schoolHome',
        component: () =>
            import('views/homechild/schoolhome')
    },
    {
        path: '/studentAppInfo',
        name: 'studentAppInfo',
        component: () =>
            import('views/appintroduction/studentAppInfo')
    },

    {
        path: '/guide',
        name: 'guide',
        component: () =>
            import('views/guide/index')
    }, {
        path: '/introduceDetail',
        name: 'introduceDetail',
        component: () =>
            import('../components/scaleIntroduceDetail')
    },
    {
        path: '/sysmgr/user',
        name: 'user',
        component: () =>
            import('views/sysmgr/user/index')
    },
    {
        path: '/sysmgr/reload',
        name: 'reload',
        component: () =>
            import('views/sysmgr/reload/index')
    },
    {
        path: '/sysmgr/role',
        name: 'role',
        component: () =>
            import('views/sysmgr/role/index')
    },
    {
        path: '/sysmgr/menu',
        name: 'menu',
        component: () =>
            import('views/sysmgr/menu/index')
    },
    {
        path: '/sysmgr/area',
        name: 'area',
        component: () =>
            import('views/sysmgr/area/index')
    },
    {
        path: '/sysmgr/shortVideo',
        name: 'shortVideo',
        component: () =>
            import('views/sysmgr/shortvideo/index')
    },
    {
        path: '/commissionMgr/eduCommission',
        name: 'eduCommission',
        component: () =>
            import('views/commissionMgr/eduCommission')
    },
    {
        path: '/edumgr/education',
        name: 'education',
        component: () =>
            import('views/edumgr/education/index')
    },
    {
        path: '/sysmgr/school',
        name: 'school',
        component: () =>
            import('views/sysmgr/school/index')
    },
    {
        path: '/sysmgr/myTask',
        name: 'myTask',
        component: () =>
            import('views/sysmgr/task/MyTask')
    },
    {
        path: '/sysmgr/myTask1',
        name: 'myTask1',
        component: () =>
            import('views/sysmgr/task/MyTask1')
    },
    {
        path: '/sysmgr/addTask',
        name: 'addTask',
        component: () =>
            import('views/sysmgr/task/AddTask')
    },
    {
        path: '/sysmgr/addPsychologyTask',
        name: 'addPsychologyTask',
        component: () =>
            import('views/sysmgr/task/addPsychologyTask')
    },
    {
        path: '/sysmgr/scale',
        name: 'scale',
        component: () =>
            import('views/sysmgr/scale/index')
    },
    // 量表设置
    {
        path: '/sysmgr/scaleSetting',
        name: 'scaleSetting',
        component: () =>
            import('views/sysmgr/scalesetting/index')
    },
    // 量表套餐管理
    {
        path: '/sysmgr/scalePackage',
        name: 'scalePackage',
        component: () =>
            import('views/sysmgr/scalepackage/index')
    },
    {
        path: '/schoolmgr/grade',
        name: 'grade',
        component: () =>
            import('views/schoolmgr/grade/index')
    },
    {
        path: '/schoolmgr/major',
        name: 'major',
        component: () =>
            import('views/schoolmgr/major/index')
    },
    {
        path: '/schoolmgr/class',
        name: 'class',
        component: () =>
            import('views/schoolmgr/class/index')
    },
    {
        path: '/schoolmgr/student',
        name: 'student',
        component: () =>
            import('views/schoolmgr/student/index')
    },
    {
        path: '/schoolmgr/studentDetail',
        name: 'studentDetail',
        component: () =>
            import('views/schoolmgr/studentdetail/index')
    },
    {
        path: '/schoolmgr/teacher',
        component: () =>
            import('views/schoolmgr/teacher/index')
    },
    {
        path: '/answermgr/answerList',
        name: 'answerList',
        component: () =>
            import('views/answermgr/answer/index')
    },
    {
        path: '/psychology/classmgr',
        name: 'classmgr',
        component: () =>
            import('views/psychology/classmgr/index')
    },
    {
        path: '/psychology/mystudy',
        name: 'mystudy',
        component: () =>
            import('views/psychology/mystudy/index')
    },
    {
        name: 'courseDetail',
        path: '/psychoEvaluation/courseDetail',
        component: () =>
            import('views/psychologyEvaluation/components/courseDetail')
    },
    {
        path: '/psychoEvaluation/courseList',
        name: 'courseList',
        component: () =>
            import('views/psychologyEvaluation/components/courseList')
    },
    {
        path: '/psychoEvaluation/record',
        name: 'evaluateList',
        component: () =>
            import('views/psychologyEvaluation/record')
    },
    {
        path: '/psychoEvaluation/answer',
        name: 'answer',
        component: () =>
            import('views/psychologyEvaluation/components/answer')
    },
    /////
    {
        path: '/riskCheck/planCheck',
        name: 'planCheck',
        component: () =>
            import('views/riskCheck/planCheck/index')
    },
    {
        path: '/riskCheck/factCheck',
        name: 'factCheck',
        component: () =>
            import('views/riskCheck/factCheck/index')
    },
    /////
    {
        path: '/psychologyTrain/trainquery',
        name: 'trainquery',
        component: () =>
            import('views/psychologyTrain/trainquery/index')
    },
    {
        path: '/psychologyTrain/myTrain',
        name: 'myTrain',
        component: () =>
            import('views/psychologyTrain/myTrain/index')
    },
    {
        path: '/psychologyTrain/trainList',
        name: 'trainList',
        component: () =>
            import('views/psychologyTrain/components/trainList')
    },
    {
        name: 'trainDetail',
        path: '/psychologyTrain/trainDetail',
        component: () =>
            import('views/psychologyTrain/components/trainDetail')
    },
    // 我的测评
    {
        path: '/psychologyEvaluation/myEvaluation',
        name: 'myEvaluation',
        component: () =>
            import('views/psychologyEvaluation/myEvaluation/index')
    },
    //调查问卷页面
    {
        path: '/psychologyEvaluation/questionnaire',
        name: 'questionnaire',
        component: () =>
            import('views/psychologyEvaluation/questionnaire/index')
    },
    //查询档案记录表页面
    {
        path: '/psychologyEvaluation/searchquestionnaire',
        name: 'searchquestionnaire',
        component: () =>
            import('views/psychologyEvaluation/searchquestionnaire/index')
    },
    // 重点关注对象
    {
        path: '/psychologyEvaluation/focus',
        name: 'focus',
        component: () =>
            import('views/psychologyEvaluation/focus/index')
    },
    // 心理测评
    {
        path: '/psychologyEvaluation/evaQuery',
        name: 'evaQuery',
        component: () =>
            import('views/psychologyEvaluation/evaquery/index')
    },
    // 家长签名记录
    {
        path: '/psychologyEvaluation/signature',
        name: 'signature',
        component: () =>
            import('views/psychologyEvaluation/signature/index')
    },
    // 辅导选择学生
    {
        path: '/psychologyEvaluation/coachStudent',
        name: 'coachStudent',
        component: () =>
            import('views/psychologyEvaluation/coachStudent/index')
    },
    // 测评告警
    {
        path: '/psychologyEvaluation/warning',
        name: 'warning',
        component: () =>
            import('views/psychologyEvaluation/warning/index')
    },
    // 量表分析
    {
        path: '/psychologyEvaluation/scaleAnalysis',
        name: 'scaleAnalysis',
        component: () =>
            import('views/psychologyEvaluation/scaleanalysis/index')
    },
    //档案管理
    {
        path: '/sysmgr/archives',
        name: 'archives',
        component: () =>
            import('views/sysmgr/archives/index')
    },
    //  添加任务选择学生界面
    {
        path: '/sysmgr/selectStudent',
        name: 'selectStudent',
        component: () =>
            import('views/sysmgr/task/SelectStudent')
    },
     // 往任务中追加学校
     {
        path: '/sysmgr/selectSchool',
        name: 'selectSchool',
        component: () =>
            import('views/sysmgr/task/selectSchool')
    },
    //  添加任务选择教师界面
    {
        path: '/sysmgr/selectTeacher',
        name: 'selectTeacher',
        component: () =>
            import('views/sysmgr/task/selectTeacher')
    },
    //  添加任务选择量表界面
    {
        path: '/sysmgr/selectScale',
        name: 'selectScale',
        component: () =>
            import('views/sysmgr/task/SelectScale')
    },
    // 选择测评量表
    {
        path: '/outsidermgr/currentScale',
        name: 'currentScale',
        component: () =>
            import('views/outsidermgr/CurrentScale')
    },

    // 校外人员名单查询
    {
        path: '/outsidermgr/outsiderQuery',
        name: 'outsiderQuery',
        component: () =>
            import('views/outsidermgr/OutsiderQuery')
    },
    // 初次辅导查询
    {
        path: '/outsidermgr/psychologyCoach/coachQuery',
        name: 'coachQuery',
        component: () =>
            import('views/outsidermgr/CoachQuery')
    },
    // 二次辅导查询
    {
        path: '/outsidermgr/psychologyCoach/secondCoachQuery',
        name: 'secondCoachQuery',
        component: () =>
            import('views/outsidermgr/secondCoachQuery')
    },
    // 辅导调查问卷页面
    {
        path: '/outsidermgr/coachQuestionnaire',
        name: 'coachQuestionnaire',
        component: () =>
            import('views/outsidermgr/CoachQuestionnaire')
    },

    ]
},
// 系统管理路由配置
// 学校管理路由配置
// 任务管理路由配置
{
    path: '/task',
    component: Layout,
    children: [
        // 系统任务
        {
            path: 'systemTask',
            name: 'systemTask',
            component: () =>
                import('views/taskmgr/systemTask')
        },
        {
            path: 'taskLog',
            name: 'taskLog',
            component: () =>
                import('views/taskmgr/taskLog')
        },
        // 教育局任务
        {
            path: 'educationTask',
            name: 'educationTask',
            component: () =>
                import('views/taskmgr/educationTask')
        },
        // 学校任务
        {
            path: 'schoolTask',
            name: 'schoolTask',
            component: () =>
                import('views/taskmgr/schoolTask')
        },
        // 心理老师任务
        {
            path: 'psychologyTask',
            name: 'psychologyTask',
            component: () =>
                import('views/taskmgr/psychologyTask')
        },
        {
            path: 'reformSelectStudent',
            name: 'reformSelectStudent',
            component: () =>
                import('views/taskmgr/reformSelectStudent')
        },
        // 历史任务
        {
            path: 'historyTask',
            name: 'historyTask',
            component: () =>
                import('views/taskmgr/historyTask')
        },
        // 任务图形分析
        {
            path: 'taskEchartsDetails',
            name: 'taskEchartsDetails',
            component: () =>
                import('views/taskmgr/taskEchartsDetails')
        },
        // 学生任务
        // 任务重做
        {
            path: 'reform',
            name: 'reform',
            component: () =>
                import('views/taskmgr/reform/studentSelect')
        },
        // 心理老师测评任务
        {
            path: 'teacherTask',
            name: 'teacherTask',
            component: () =>
                import('views/taskmgr/teacherTask')
        },
        // 心理老师历史测评任务
        {
            path: 'teacherHistoryTask',
            name: 'teacherHistoryTask',
            component: () =>
                import('views/taskmgr/teacherHistoryTask')
        },
        // 添加心理老师测评任务
        {
            path: 'addTeacherTask',
            name: 'addTeacherTask',
            component: () =>
                import('views/taskmgr/addTeacherEvaluateTask')
        },
       
        // 教育局测评任务列表
        {
            path: 'eduTask',
            name: 'eduTask',
            component: () =>
                import('views/taskmgr/eduTask')
        },
        // 添加教育局测评任务
        {
            path: 'addEduTask',
            name: 'addEduTask',
            component: () =>
                import('views/taskmgr/addEduTask')
        }
    ]
},
//校外人员管理路由配置
{
    path: '/outsidermgr',
    component: Layout,
    children: [
        // 心理测评
        {
            path: 'psychologyEvaluationOutside',
            name: 'psychologyEvaluationOutside',
            component: () =>
                import('views/outsidermgr/Registration'),
            children: [{
                path: 'registration',
                name: 'registration',
                component: () =>
                    import('views/outsidermgr/Registration')
            }]
        },
        // 心理辅导
        {
            path: 'psychologyCoach',
            name: 'psychologyCoach',
            component: () =>
                import('views/outsidermgr/CoachRegister'),
            children: [
                // 辅导登记
                {
                    path: 'coachRegister',
                    name: 'coachRegister',
                    component: () =>
                        import('views/outsidermgr/CoachRegister')
                },
            ]
        },
    ]
},
// 重点学生路由配置
{
    path: '/',
    component: Layout,
    children: [{
        path: '/keyStudent',
        name: 'keyStudent',
        component: () =>
            import('views/keyStudent/index')
    },
    {
        path: '/historyKeyStudent',
        name: 'historyKeyStudent',
        component: () =>
            import('views/keyStudent/historyKeyStudent')
    }
    ],
},
// 学生体检管理
{
    path: '/',
    component: Layout,
    children: [
        // 体检学生选择
        {
            path: '/examineSelect',
            name: 'examineSelect',
            component: () =>
                import('views/examinemgr/examineSelect')
        },
        // 体检登记
        {
            path: '/examineRegister',
            name: 'examineRegister',
            component: () =>
                import('views/examinemgr/examineRegister')
        },
        // 学生体检记录
        {
            path: '/examineRecord',
            name: 'examineRecord',
            component: () =>
                import('views/examinemgr/examineRecord')
        }

    ],
},
// 问卷调查管理
{
    path: '/hquestionnaire',
    component: Layout,
    children: [
        //问卷列表管理
        {
            path: '/questionnaireList',
            name: 'questionnaireList',
            component: () =>
                import('views/questionnairemgr/questionnaireList')
        },

        // 问卷记录
        {
            path: '/questionnaireRecords',
            name: 'questionnaireRecords',
            component: () =>
                import('views/questionnairemgr/questionnaireRecords')
        },
    ]
},
// 心理访谈路由配置
{
    path: '/interview',
    component: Layout,
    children: [{
        path: 'again',
        name: 'interviewAgain',
        component: () =>
            import('views/interview/again/index')
    },
    {
        path: 'secondInterview', // 再次访谈 
        name: 'secondInterview',
        component: () =>
            import('views/interview/secondinterview/index')
    }
    ],
},
// 教育厅、教育局管理
{
    path: '/education',
    component: Layout,
    children: [{
        path: 'department',
        name: 'educationDepartmentList',
        component: () =>
            import('views/edumgr/department/index')
    }],
},
//交流中心
{
    path: '/communicationmgr',
    component: Layout,
    meta: {
        title: '交流中心',
        icon: 'el-icon-s-order',
    },
    children: [{
        path: '/teacherList',
        name: 'teacherList',
        meta: {
            title: '心理老师列表',
            icon: 'el-icon-tickets'
        },
        component: () =>
            import('views/communicationmgr/teacherList')
    },
    {
        path: '/communicationChat',
        name: 'communicationChat',
        meta: {
            title: '交流聊天',
            icon: 'el-icon-tickets'
        },
        component: () =>
            import('views/communicationmgr/communicationChat')
    },

    ]
},
// 心理老师课程学习管理
{
    path: '/coursemgr',
    component: Layout,
    meta: {
        title: '视频课程管理',
        icon: 'el-icon-s-platform',
    },
    children: [{
        path: '/playRecord',
        name: 'playRecord',
        meta: {
            title: '课程学习记录',
            icon: 'el-icon-s-management'
        },
        component: () =>
            import('views/coursemgr/index')
    },
    {
        path: '/studyClass',
        name: 'studyClass',
        meta: {
            title: '心理老师课程学习',
            icon: 'el-icon-s-management'
        },
        component: () =>
            import('views/coursemgr/studyClass')
    },
    {
        path: '/studyClassDetail',
        name: 'studyClassDetail',
        meta: {
            title: '心理老师课程学习',
            icon: 'el-icon-s-management'
        },
        component: () =>
            import('views/coursemgr/studyClassDetail')
    },
    {
        path: '/studyTestList',
        name: 'studyTestList',
        meta: {
            title: '课程学习答题',
            icon: 'el-icon-s-management'
        },
        component: () =>
            import('views/coursemgr/studyTestList')
    },
    {
        path: '/studyTestDetail',
        name: 'studyTestDetail',
        meta: {
            title: '课程学习答题',
            icon: 'el-icon-s-management'
        },
        component: () =>
            import('views/coursemgr/studyTestDetail')
    },



    ]
},
]

const router = new Router({
    routes,
    mode: 'history'
})

const whiteList = ['/login', '/facialInput', '/forgetPassword', '/appIntroduce', '/registeredNumber', '/answerRegister', '/outsiderAnswerList', '/outsiderAnswer', '/task/reform', "/answermgr/answerList",
    '/psychoEvaluation/answer', '/sysmgr/myTask', "/psychologyTrain/trainDetail", "/psychoEvaluation/courseDetail", "/psychologyEvaluation/myEvaluation", "/psychology/mystudy", "/psychologyTrain/myTrain"
] // 不重定向白名单
router.beforeEach((to, from, next) => {
    if (LYCom.GetLYToken()) {
        if (to.path === '/login') {
            if (store.getters.menus) {
                let first = store.getters.menus.find(e => e.name == 'home')
                if (first) {
                    next(first.url)
                }
            } else {
                next()
            }
        } else {
            if (store.getters.currentRoleGroup == null && LYCom.GetLYToken()) {
                store.dispatch('GetInfo').then(res => { // 拉取用户信息
                    let permisions = {
                        'menus': res.permissions,
                        'schools': [],
                        'currentSchool': null,
                        'currentRoleGroup': res.currentRoleGroup,
                        'currentOrganizationId': res.currentOrganizationId,
                        'currentOrganizationName': res.organizationName
                    }
                    let currentEnterOrgInfo = window.sessionStorage.getItem('currentEnterOrgInfo');

                    if (currentEnterOrgInfo) {
                        currentEnterOrgInfo = JSON.parse(currentEnterOrgInfo);
                        permisions.currentRoleGroup = currentEnterOrgInfo.roleGroup
                        permisions.currentOrganizationId = currentEnterOrgInfo.organizationId
                        permisions.currentOrganizationName = currentEnterOrgInfo.organizationName
                        store.commit("setEnterOrg", true);
                    }

                    store.dispatch('GeneratePermisions', permisions)
                    //获取首页
                    if (to.name == 'home') {
                        let first = res.permissions.find(e => e.name == 'home')
                        if (first) {
                            next(first.url)
                        }
                        // 如果是学生跳转到我的任务
                        if (res.CurrentRoleGroup == 8) {
                            next('/sysmgr/myTask')
                        }
                    }
                    next()
                })
                    .catch((err) => {
                        store.dispatch('FedLogOut').then(() => {
                            let errMsg = '验证失败, 请重新登录'
                            if (err) {
                                errMsg = err.toString()
                            }
                            Message.error(errMsg)
                            next({
                                path: '/'
                            })
                        })
                    })
            } else {
                if (to.path == "/home" && store.getters.menus) {
                    let first = store.getters.menus.find(e => e.name == 'home')
                    // console.log(store.getters.menus);
                    // console.log(first);
                    if (first && first.url != to.path) {
                        // console.log(first.url);
                        next(first.url)
                    } else {
                        // 如果是学生跳转到我的任务
                        if (store.getters.currentRoleGroup == 8) {
                            next('/sysmgr/myTask')
                        } else {
                            next()
                        }
                    }
                } else {
                    next()
                }

            }
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            next({
                path: '/login'
            })
        }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js